import { render, staticRenderFns } from "./teacherEvaluate.vue?vue&type=template&id=22208db0&scoped=true&"
import script from "./teacherEvaluate.vue?vue&type=script&lang=ts&"
export * from "./teacherEvaluate.vue?vue&type=script&lang=ts&"
import style0 from "./teacherEvaluate.vue?vue&type=style&index=0&id=22208db0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22208db0",
  null
  
)

export default component.exports